import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TradeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M22.2109 1H9.78906C4.9375 1 1 4.9375 1 9.78906V22.2109C1 27.0625 4.9375 31 9.78906 31H22.2109C27.0625 31 31 27.0625 31 22.2109V9.78906C31 4.9375 27.0625 1 22.2109 1ZM17.3301 25.2812L10.0352 17.9863L8.04883 19.9727V13.3457H14.6758L12.6895 15.332L19.9844 22.627L17.3301 25.2812ZM23.957 18.6484H17.3301L19.3164 16.6621L12.0215 9.37305L14.6758 6.71875L21.9707 14.0078L23.957 12.0215V18.6484Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
